import { render, staticRenderFns } from "./MoreInfo.vue?vue&type=template&id=d5a38e94&scoped=true&"
import script from "./MoreInfo.vue?vue&type=script&lang=js&"
export * from "./MoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./MoreInfo.vue?vue&type=style&index=0&id=d5a38e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a38e94",
  null
  
)

export default component.exports